"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeHandlerSelectionAdapter_1 = require("./NodeHandlerSelectionAdapter");
/**
 * Converts GraphQL fragment spread to one or more quad patterns with a given type within an optional.
 */


var NodeHandlerSelectionFragmentSpread =
/*#__PURE__*/
function (_NodeHandlerSelection) {
  _inherits(NodeHandlerSelectionFragmentSpread, _NodeHandlerSelection);

  function NodeHandlerSelectionFragmentSpread(util, settings) {
    _classCallCheck(this, NodeHandlerSelectionFragmentSpread);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeHandlerSelectionFragmentSpread).call(this, 'FragmentSpread', util, settings));
  }

  _createClass(NodeHandlerSelectionFragmentSpread, [{
    key: "handle",
    value: function handle(fragmentSpreadNode, convertContext) {
      var fragmentDefinitionNode = convertContext.fragmentDefinitions[fragmentSpreadNode.name.value];

      if (!fragmentDefinitionNode) {
        throw new Error('Undefined fragment definition: ' + fragmentSpreadNode.name.value);
      } // Wrap in an OPTIONAL, as this pattern should only apply if the type applies


      var fieldNode = {
        alias: null,
        arguments: null,
        directives: fragmentDefinitionNode.directives,
        kind: 'Field',
        name: fragmentSpreadNode.name,
        selectionSet: fragmentDefinitionNode.selectionSet
      };
      var auxiliaryPatterns = [this.util.newTypePattern(convertContext.subject, fragmentDefinitionNode.typeCondition, convertContext)];
      return this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), this.fieldToOperation(convertContext, fieldNode, false, auxiliaryPatterns));
    }
  }]);

  return NodeHandlerSelectionFragmentSpread;
}(NodeHandlerSelectionAdapter_1.NodeHandlerSelectionAdapter);

exports.NodeHandlerSelectionFragmentSpread = NodeHandlerSelectionFragmentSpread;